import styles from './AccordionList.module.scss';

interface AccordionListProps {
  children: React.ReactNode;
}

export const AccordionList = ({ children }: AccordionListProps) => (
  <ul className={styles.list}>{children}</ul>
);
